import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import { formatRupees } from "../../../utils/inputsValidation";

export const TableTwo = ({ capitalGainResult, forceExpand = false, selectedYr }) => {
    const [visibleIndexes, setVisibleIndexes] = useState({});
    // const data = capitalGainResult?.result || [];
    const raw = capitalGainResult?.result || [];
      const data = raw?.length > 0 ? raw?.slice(0, -1) : [];

    const toggleVisibility = (fundIndex) => {
        setVisibleIndexes((prev) => ({
            ...prev,
            [fundIndex]: !prev[fundIndex],
        }));
    };

    let grandTotals = { subAmount: 0, subUnit: 0, redempAmount: 0, redempUnit: 0, gainLoss: 0 };

    return (
      <>
        <div className="d-none d-md-block ">

            {data.map((fund, fundIndex) => {
                // Merge FundDetail by ISIN + Folio
                const mergedDetails = {};
                fund.FundDetail.forEach((detail) => {
                    const key = fund.Fund
                    if (!mergedDetails[key]) {
                        mergedDetails[key] = { ...detail, Transaction: [...detail.Transaction], Total: { ...detail.Total } };
                    } else {
                        mergedDetails[key].Transaction.push(...detail.Transaction);
                        mergedDetails[key].Total.SubAmount += detail.Total.SubAmount;
                        mergedDetails[key].Total.SubUnit += detail.Total.SubUnit;
                        mergedDetails[key].Total.RedempAmount += detail.Total.RedempAmount;
                        mergedDetails[key].Total.RedempUnit += detail.Total.RedempUnit;
                        mergedDetails[key].Total.Gainloss += detail.Total.Gainloss;
                    }
                });

                const detailsArray = Object.values(mergedDetails);
                grandTotals.gainLoss += fund.FundTotal.Gainloss;

                return (
                    <div key={fundIndex} className="table-scroll-cgr">
                        <table className="table">
                            <thead>
                                <tr className="odd">
                                    <th colSpan="13" >
                                        <p className="fs-14 fw-bold">{fund.Category} {fund.Sub_Category}</p>
                                        {/* <p className="fs-14 fw-bold">{fund.Fund}</p> */}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {detailsArray.map((detail, detailIndex) => {
                                    const isVisible = visibleIndexes[`${fundIndex}-${detailIndex}`] ;
                                    return (
                                        <React.Fragment key={detailIndex}>
                                            <tr>
                                                <th className="back-clrgreen txt-color-revers"
                                                 colSpan="13" onClick={() => toggleVisibility(`${fundIndex}-${detailIndex}`)} style={{ cursor: "pointer" }}>
                                                    {isVisible ? <FaMinus /> : <FaPlus />} {detail.Scheme} (Folio No: {detail.Folio}) (ISIN No: {detail.ISIN_NO})
                                                </th>
                                            </tr>

                                            {isVisible && (
                                                <>
                                                    <tr className="row3 green-bg port0">
                                                        <th colSpan="5" className="txt-color">Subscriptions</th>
                                                        <th colSpan="6" className="txt-color">Redemptions</th>
                                                        <th className="txt-color">Capital G/L</th>
                                                    </tr>
                                                    
                                                    <tr className="port0" >
                                                        {[
                                                            "Trxn Type", "Date", "Amount", "Unit", "Cost",
                                                            "Trxn Type", "Date", "Amount", "Unit", "Price", "Days", "Gain / Loss"
                                                        ].map((h, i) => <th className="back-clrgreen txt-color-revers" key={i}>{h}</th>)}
                                                    </tr>
                                                    {detail?.Transaction.map((tx, i) => (
                                                        <tr key={i}>
                                                            <td>{tx["Sub Trans Type"]}</td>
                                                            <td>{tx["Sub Date"]}</td>
                                                            <td>{formatRupees(tx["Sub Amount"])}</td>
                                                            <td>{tx["Sub Unit"]}</td>
                                                            <td>{tx["Sub Cost"]}</td>
                                                            <td>{tx["Redemp Trans Type"]}</td>
                                                            <td>{tx["Redemp Date"]}</td>
                                                            <td>{formatRupees(tx["Redemp Amount"])}</td>
                                                            <td>{Number(tx["Redemp Unit"]).toFixed(2)}</td>
                                                            <td>{formatRupees(tx["Redemp Price"])}</td>
                                                            <td>{tx["Days"]}</td>
                                                            {/* <td>{tx["Index Cost"] || "-"}</td> */}
                                                            <td>{formatRupees(tx["Gainloss"])}</td>
                                                        </tr>
                                                    ))}
                                                    {/* <tr className="grey-bg total">
                                                        <td colSpan="2">Total</td>
                                                        <td>{Number(detail.Total.SubAmount).toFixed(2)}</td>
                                                        <td>{Number(detail.Total.SubUnit).toFixed(2)}</td>
                                                        <td colSpan="3"></td>
                                                        <td>{Number(detail.Total.RedempAmount).toFixed(2)}</td>
                                                        <td>{Number(detail.Total.RedempUnit).toFixed(2)}</td>
                                                        <td colSpan="2">Total Gain / Loss</td>
                                                        <td>{Number(detail.Total.Gainloss).toFixed(2)}</td>
                                                    </tr> */}

                                                     <tr className="grey-bg">
                                                        <td colSpan="2" className="fw-bold">{fund.Category} {fund.Sub_Category} Total</td>
                                                        <td>{Number(fund.FundTotal.SubAmount).toFixed(2)}</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>{Number(fund.FundTotal.RedempAmount).toFixed(2)}</td>
                                                        <td></td>
                                                        <td colSpan="2" className="fw-bold">Total Gain / Loss</td>
                                                        <td>{Number(fund.FundTotal.Gainloss).toFixed(2)}</td>
                                                    </tr>
                                                </>
                                            )}
                                        </React.Fragment>
                                    );
                                })}

                                {/* <tr className="grey-bg">
                                    <td colSpan="2" className="fw-bold">{fund.Category} {fund.Sub_Category} Total</td>
                                    <td>{Number(fund.FundTotal.SubAmount).toFixed(2)}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{Number(fund.FundTotal.RedempAmount).toFixed(2)}</td>
                                    <td></td>
                                    <td colSpan="2" className="fw-bold">Total Gain / Loss</td>
                                    <td>{Number(fund.FundTotal.Gainloss).toFixed(2)}</td>
                                </tr> */}
                            </tbody>
                        </table>
                    </div>
                );
            })}
            {/* <div className="mt-3 fw-bold fs-14">
                Total Gain / Loss for Financial {selectedYr}: {grandTotals.gainLoss.toFixed(2)}
            </div> */}
        </div>
        {/* ===================== MOBILE VIEW ===================== */}
        <div className="d-block d-md-none mt-3">

        {data.map((fund, fundIndex) => {
            // Merge FundDetail same as desktop
            const mergedDetails = {};
            fund.FundDetail.forEach((detail) => {
            const key = `${detail.ISIN_NO}-${detail.Folio}`;
            if (!mergedDetails[key]) {
                mergedDetails[key] = { 
                ...detail, 
                Transaction: [...detail.Transaction], 
                Total: { ...detail.Total } 
                };
            } else {
                mergedDetails[key].Transaction.push(...detail.Transaction);
                mergedDetails[key].Total.SubAmount += detail.Total.SubAmount;
                mergedDetails[key].Total.SubUnit += detail.Total.SubUnit;
                mergedDetails[key].Total.RedempAmount += detail.Total.RedempAmount;
                mergedDetails[key].Total.RedempUnit += detail.Total.RedempUnit;
                mergedDetails[key].Total.Gainloss += detail.Total.Gainloss;
            }
            });

            const detailsArray = Object.values(mergedDetails);

            return (
            <div key={fundIndex} className="mb-4">

                {/* CATEGORY HEADER */}
                <p className="fw-bold fs-5 text-success">
                {fund.Category} {fund.Sub_Category}
                </p>

                {/* DETAILS */}
                {detailsArray.map((detail, detailIndex) => {
                const cardId = `${fundIndex}-${detailIndex}`;
                const isVisible = visibleIndexes[cardId];

                return (
                    <div key={detailIndex} className="card shadow-sm mb-3 p-2">

                    {/* CARD HEADER */}
                    <div
                        className="d-flex justify-content-between align-items-center"
                        onClick={() => toggleVisibility(cardId)}
                        style={{ cursor: "pointer" }}
                    >
                        <p className="fw-bold mb-0">
                        {detail.Scheme}
                        <br />
                        <span className="text-color fs-12">
                            Folio: {detail.Folio} | ISIN: {detail.ISIN_NO}
                        </span>
                        </p>

                        {isVisible ? (
                        <FaMinus className="fs-4 text-success" />
                        ) : (
                        <FaPlus className="fs-4 text-success" />
                        )}
                    </div>

                    {/* BODY */}
                    {isVisible && (
                        <div className="mt-2">

                        {/* Subscriptions & Redemptions Label */}
                        <div className="d-flex justify-content-between py-2 border-bottom">
                            <span className="fw-bold text-success">Subscriptions</span>
                        </div>

                        {/* TRANSACTIONS */}
                        {detail.Transaction.map((tx, i) => (
                            <div key={i} className="border-bottom py-2">

                            <div className="d-flex justify-content-between">
                                <span className="fw-bold">Sub Type:</span>
                                <span>{tx["Sub Trans Type"]}</span>
                            </div>

                            <div className="d-flex justify-content-between">
                                <span className="fw-bold">Sub Date:</span>
                                <span>{tx["Sub Date"]}</span>
                            </div>

                            <div className="d-flex justify-content-between">
                                <span className="fw-bold">Sub Amount:</span>
                                <span>{formatRupees(tx["Sub Amount"])}</span>
                            </div>

                            <div className="d-flex justify-content-between">
                                <span className="fw-bold">Sub Units:</span>
                                <span>{tx["Sub Unit"]}</span>
                            </div>

                            <hr />
                            <div className="d-flex justify-content-between py-2 border-bottom">
                            {/* <span className="fw-bold text-success">Subscriptions</span> */}
                            <span className="fw-bold text-danger">Redemptions</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span className="fw-bold">Redemp Type:</span>
                                <span>{tx["Redemp Trans Type"]}</span>
                            </div>

                            <div className="d-flex justify-content-between">
                                <span className="fw-bold">Redemp Date:</span>
                                <span>{tx["Redemp Date"]}</span>
                            </div>

                            <div className="d-flex justify-content-between">
                                <span className="fw-bold">Redemp Amount:</span>
                                <span>{formatRupees(tx["Redemp Amount"])}</span>
                            </div>

                            <div className="d-flex justify-content-between">
                                <span className="fw-bold">Redemp Units:</span>
                                <span>{Number(tx["Redemp Unit"]).toFixed(2)}</span>
                            </div>

                            <div className="d-flex justify-content-between">
                                <span className="fw-bold">Days:</span>
                                <span>{tx["Days"]}</span>
                            </div>

                            <hr />
                            <div className="d-flex justify-content-between py-2 border-bottom">
                            {/* <span className="fw-bold text-success">Subscriptions</span> */}
                            <span className="fw-bold text-primary">Capital Gain</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span className="fw-bold ">Gain/Loss:</span>
                                <span>{formatRupees(tx["Gainloss"])}</span>
                            </div>

                            </div>
                        ))}

                        {/* TOTALS */}
                        <div className="p-2 mt-2 back-clrgreen txt-color-revers">
                            <p className="fw-bold mb-1 txt-color-revers">Totals:</p>

                            <div className="d-flex justify-content-between">
                            <span>Sub Amount:</span>
                            <span>{Number(fund.FundTotal.SubAmount).toFixed(2)}</span>
                            </div>

                            {/* <div className="d-flex justify-content-between">
                            <span>Sub Units:</span>
                            <span>{Number(detail.Total.SubUnit).toFixed(2)}</span>
                            </div> */}

                            <div className="d-flex justify-content-between">
                            <span>Redemp Amount:</span>
                            <span>{Number(fund.FundTotal.RedempAmount).toFixed(2)}</span>
                            </div>

                            {/* <div className="d-flex justify-content-between">
                            <span>Redemp Units:</span>
                            <span>{Number(detail.Total.RedempUnit).toFixed(2)}</span>
                            </div> */}

                            <div className="d-flex justify-content-between fw-bold">
                            <span>Gain / Loss:</span>
                            <span>{Number(fund.FundTotal.Gainloss).toFixed(2)}</span>
                            </div>

                        </div>

                        

                        </div>
                    )}
                    </div>
                );
                })}

                {/* CATEGORY TOTAL */}
                <div className="bg-light  p-2  fw-bold">
                Total Gain/Loss: {Number(fund.FundTotal.Gainloss).toFixed(2)}
                </div>

            </div>
            );
        })}
        </div>

        </>

        
    );
};
